import { CurrencyRange, CurrencyRangeType } from './tm-currency-range';

export const mapCurrencyRangeToDto = (currencyRange?: CurrencyRange, specificRange = true) => {
    if (!currencyRange) {
        return {
            operator: undefined,
            fromAmount: undefined,
            toAmount: undefined,
            specificAmount: undefined,
        };
    }

    const { rangeType, specificAmount, floorAmount, ceilAmount: toAmount } = currencyRange;
    switch (rangeType) {
        case CurrencyRangeType.AllAmounts:
            return {
                toAmount,
                specificAmount,
            };
        case CurrencyRangeType.AmountRange:
        case CurrencyRangeType.Between:
            return {
                operator: specificRange ? 'Amount Range' : 'Range',
                fromAmount: floorAmount === 0 && toAmount && toAmount > 0 ? 0.01 : floorAmount,
                toAmount,
                specificAmount,
            };
        case CurrencyRangeType.SpecificAmount:
            return {
                operator: 'Specific Amount',
                fromAmount: specificAmount,
                toAmount,
                specificAmount,
            };
        case CurrencyRangeType.LessThan:
            return {
                operator: 'Less Than',
                fromAmount: 0,
                toAmount,
                specificAmount,
            };
        case CurrencyRangeType.GreaterThan:
            return {
                operator: 'Greater Than',
                fromAmount: floorAmount,
                toAmount,
                specificAmount,
            };
        default:
            throw new Error(`Invalid range type: "${rangeType}"`);
    }
};
